// // src/routes.ts
// import { RouteObject } from 'react-router';
// import Overview from 'src/content/overview';
// import Crypto from 'src/content/dashboards/Crypto';
// import Messenger from 'src/content/applications/Messenger';
// import Transactions from 'src/content/applications/Transactions';
// import UserProfile from 'src/content/applications/Users/profile';
// import UserSettings from 'src/content/applications/Users/settings';
// import Buttons from 'src/content/pages/Components/Buttons';
// import Modals from 'src/content/pages/Components/Modals';
// import Accordions from 'src/content/pages/Components/Accordions';
// import Tabs from 'src/content/pages/Components/Tabs';
// import Badges from 'src/content/pages/Components/Badges';
// import Tooltips from 'src/content/pages/Components/Tooltips';
// import Avatars from 'src/content/pages/Components/Avatars';
// import Cards from 'src/content/pages/Components/Cards';
// import Forms from 'src/content/pages/Components/Forms';
// import Status404 from 'src/content/pages/Status/Status404';
// import Status500 from 'src/content/pages/Status/Status500';
// import StatusComingSoon from 'src/content/pages/Status/ComingSoon';
// import StatusMaintenance from 'src/content/pages/Status/Maintenance';

// const routes: RouteObject[] = [
//   {
//     path: '/',
//     element: <Overview />,
//   },
//   {
//     path: '/dashboards',
//     children: [
//       { path: 'crypto', element: <Crypto /> },
//       { path: 'messenger', element: <Messenger /> },
//     ],
//   },
//   {
//     path: '/management',
//     children: [
//       { path: 'transactions', element: <Transactions /> },
//       {
//         path: 'profile',
//         children: [
//           { path: 'details', element: <UserProfile /> },
//           { path: 'settings', element: <UserSettings /> },
//         ],
//       },
//     ],
//   },
//   {
//     path: '/components',
//     children: [
//       { path: 'buttons', element: <Buttons /> },
//       { path: 'modals', element: <Modals /> },
//       { path: 'accordions', element: <Accordions /> },
//       { path: 'tabs', element: <Tabs /> },
//       { path: 'badges', element: <Badges /> },
//       { path: 'tooltips', element: <Tooltips /> },
//       { path: 'avatars', element: <Avatars /> },
//       { path: 'cards', element: <Cards /> },
//       { path: 'forms', element: <Forms /> },
//     ],
//   },
//   {
//     path: '/status',
//     children: [
//       { path: '404', element: <Status404 /> },
//       { path: '500', element: <Status500 /> },
//       { path: 'maintenance', element: <StatusMaintenance /> },
//       { path: 'coming-soon', element: <StatusComingSoon /> },
//     ],
//   },
//   {
//     path: '*',
//     element: <Status404 />,
//   },
// ];

// export default routes;

// src/router.ts
import { lazy } from 'react';
import { RouteObject } from 'react-router';

const HomePage = lazy(() => import('./components/HomePage/homepage'));
const Clients = lazy(() => import('./components/ClientsPage/clients'));
const Sales = lazy(() => import('./components/SalesPage/sales'));
const Reports = lazy(() => import('./components/Reports/reports'));
const SalesTaxReport = lazy(
  () => import('./components/Reports/salesTaxReport')
);
const ClientsForm = lazy(() => import('./components/ClientsForm/clientsForm'));
const Employees = lazy(() => import('./components/EmployeesPage/employees'));
const PrintView = lazy(() => import('./components/viewClient/printView'));
const Payroll = lazy(() => import('./components/Payroll/payroll'));
const PayrollRunDayReport = lazy(
  () => import('./components/Reports/payrollRunDayReport')
);
const SalesReport = lazy(() => import('./components/Reports/salesReport'));
const PayrollReport = lazy(() => import('./components/Reports/payrollReport'));
const EmployeeReport = lazy(
  () => import('./components/Reports/employeeReport')
);
const OwnershipReport = lazy(
  () => import('./components/Reports/ownershipReport')
);
const ClientDetails = lazy(() => import('./components/Reports/clientReport'));
const Todo = lazy(() => import('./components/Todos/todo'));
const PayrollStatus = lazy(() => import('./components/Reports/payrollStatus'));
const BusinessTax = lazy(
  () => import('./components/BusinessTaxPage/BusinessTax')
);
const ClientsCustom = lazy(
  () => import('./components/Reports/clientCustomReport')
);
const AnnualReport = lazy(() => import('./components/Reports/annualReport'));
const BookKeepingReport = lazy(
  () => import('./components/Reports/bookKeepingReport')
);
const DocumentGenerator = lazy(() => import('./components/DocumentGenerator/DocumentGenerator'));
const EditTemplatePage = lazy(() => import('./components/Templates/EditTemplatePage'));

export interface AppRoute {
  path: string;
  element: JSX.Element;
  // Permission key required to see this route. Omit for routes any
  // authenticated user can reach (e.g. the home page).
  permission?: string;
}

// Single source of truth for every route + the permission needed to reach
// it, replacing the old adminRoutes/employeeRoutes dual-array split (which
// only covered a role-vs-role split, not a real per-permission one) and the
// module-scope `localStorage` read that made role changes require a full
// page reload to take effect.
const ALL_ROUTES: AppRoute[] = [
  { path: '/', element: <HomePage /> },
  { path: '/employees', element: <Employees />, permission: 'employees.view' },
  { path: '/clients', element: <Clients />, permission: 'clients.view' },
  { path: '/sales', element: <Sales />, permission: 'sales.view' },
  { path: '/businessTax', element: <BusinessTax />, permission: 'yearlyBusinessTax.view' },
  { path: '/payroll', element: <Payroll />, permission: 'payroll.view' },
  { path: '/reports', element: <Reports />, permission: 'reports.view' },
  // Todo has no dedicated permission in the catalog and was already
  // admin-only (not even linked from the nav); preserved as a hardcoded
  // admin check rather than inventing a one-off permission key for it.
  { path: '/todo', element: <Todo />, permission: '__adminOnly' },
  { path: '/salesTaxReport', element: <SalesTaxReport />, permission: 'sales.view' },
  { path: '/salesReport', element: <SalesReport />, permission: 'sales.view' },
  { path: '/payrollRunDayReport', element: <PayrollRunDayReport />, permission: 'payroll.view' },
  { path: '/payrollReport', element: <PayrollReport />, permission: 'payroll.view' },
  { path: '/ownershipReport', element: <OwnershipReport />, permission: 'reports.view' },
  { path: '/employeeReport', element: <EmployeeReport />, permission: 'reports.view' },
  { path: '/services', element: <ClientDetails />, permission: 'clients.view' },
  { path: '/payrollStatusReport', element: <PayrollStatus />, permission: 'payroll.view' },
  { path: '/clientsCustomReport', element: <ClientsCustom />, permission: 'reports.view' },
  { path: '/annualReport', element: <AnnualReport />, permission: 'reports.view' },
  { path: '/print', element: <PrintView />, permission: 'clients.view' },
  { path: '/bookKeepingReport', element: <BookKeepingReport />, permission: 'reports.view' },
  { path: '/document-generator', element: <DocumentGenerator />, permission: 'templates.view' },
  { path: '/templates/new', element: <EditTemplatePage />, permission: 'templates.create' },
  { path: '/templates/edit/:id', element: <EditTemplatePage />, permission: 'templates.edit' }
  // Roles & Permissions management lives inside the Employees page (as a
  // modal), not as its own route — see EmployeesPage/employees.tsx.
];

export const getVisibleRoutes = (
  hasPermission: (permissionKey: string) => boolean,
  role?: string
): AppRoute[] => {
  return ALL_ROUTES.filter((route) => {
    if (!route.permission) return true;
    if (route.permission === '__adminOnly') return role === 'admin';
    return hasPermission(route.permission);
  });
};

export default ALL_ROUTES;
